"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationLogReceiverRecord = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const notification_event_type_entity_1 = require("./notification-event-type.entity");
const user_1 = require("./user");
let NotificationLogReceiverRecord = class NotificationLogReceiverRecord {
};
exports.NotificationLogReceiverRecord = NotificationLogReceiverRecord;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], NotificationLogReceiverRecord.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "log_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NotificationLogReceiverRecord.prototype, "logId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "receiver_email_id", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], NotificationLogReceiverRecord.prototype, "receiverEmailId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "receiver_user_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NotificationLogReceiverRecord.prototype, "receiverUserId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => notification_event_type_entity_1.NotificationEventType),
    (0, typeorm_1.JoinColumn)({ name: 'log_id' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof notification_event_type_entity_1.NotificationEventType !== "undefined" && notification_event_type_entity_1.NotificationEventType) === "function" ? _a : Object)
], NotificationLogReceiverRecord.prototype, "log", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_1.User),
    (0, typeorm_1.JoinColumn)({ name: 'receiver_user_id' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof user_1.User !== "undefined" && user_1.User) === "function" ? _b : Object)
], NotificationLogReceiverRecord.prototype, "receiverUser", void 0);
exports.NotificationLogReceiverRecord = NotificationLogReceiverRecord = tslib_1.__decorate([
    (0, typeorm_1.Entity)('notification_log_receiver_record')
], NotificationLogReceiverRecord);
